import { FC } from "react";
import ActionButton from "components/Buttons/ActionButton";

const ProductDeleteModal: FC<{
  setShowDeleteModal: Function;
  productType: string;
  onDelete: () => void;
  loading: boolean;
}> = ({ setShowDeleteModal, productType, onDelete, loading }) => {
  return (
    <div className="fixed inset-0 bg-transparent z-50 p-2 md:flex md:flex-row md:justify-center md:items-center">
      <div
        className="fixed inset-0 bg-black/60 -z-20"
        onClick={() => {
          if (!loading) {
            setShowDeleteModal(false);
          }
        }}
      />
      <div className="w-[300px] sm:w-[560px] bg-[#e4e6e9] shadow-[0_0_64px_#000] mx-auto h-fit rounded-b-[6px]">
        <h3 className="bg-[#0078AE] max-w-[600px] text-[#000] font-semibold flex justify-between py-2 px-2">
          <span className="text-[16px] leading-5">
            {productType === "productsOption" && "Delete Product Option"}
            {productType === "productPriceTable" &&
              "Delete Product Price Table"}
            {productType === "productCategory" && "Delete Category"}
            {productType === "productList" && "Delete Product"}
          </span>
          <span className="inline-flex justify-center items-center text-red-600">
            <i
              onClick={() => {
                if (!loading) {
                  setShowDeleteModal(false);
                }
              }}
              className={`${
                loading ? "cursor-not-allowed" : "cursor-pointer"
              } icon-cancel text-white`}
            />
          </span>
        </h3>
        <p className="font-semibold text-sm text-center p-6">
          Are you sure want delete this{" "}
          {productType === "productsOption" && "option"}
          {productType === "productPriceTable" && "product price table"}
          {productType === "productCategory" && "category"}
          {productType === "productList" && "product"}?
        </p>
        <div className="flex justify-center gap-4 p-3">
          <ActionButton
            buttonName="Cancel"
            className={`${
              loading ? "cursor-not-allowed" : "cursor-pointer"
            } bg-[#A0A0A0]  border-[#A0A0A0] hover:bg-[#888] whitespace-nowrap`}
            buttonType="button"
            onClick={() => {
              if (!loading) {
                setShowDeleteModal(false);
              }
            }}
          />
          <ActionButton
            buttonName="Delete"
            buttonType="button"
            className={`${
              loading
                ? "bg-[#D15B47]/60 border-[#D15B47]/60  cursor-not-allowed"
                : "bg-[#D15B47] border-[#D15B47] hover:bg-[#B74635] cursor-pointer"
            } `}
            onClick={onDelete}
            icon={loading ? "icon-spin4" : ""}
            loading={loading}
          />
        </div>
      </div>
    </div>
  );
};

export default ProductDeleteModal;
